export function textToHTML(htmlString: string): HTMLElement[] {
    let html: HTMLElement[] = [];
    let div = document.createElement("DIV");
    if (htmlString) {
        div.innerHTML = htmlString;
        let amount = div.children.length;
        while (amount) {
            html.push(<HTMLElement>div.removeChild(div.children[0]));
            amount--;
        }
    }
    return html;
}

export const show = (element: HTMLElement) => {
    element.style.display = "block";
};

export const hide = (element: HTMLElement) => {
    element.style.display = "none";
};
